import * as React from "react";

export const ShortcutProductsIcon = (props: any) => (
  <svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 26v4"
      stroke="#2D5BFF"
      strokeWidth={2.125}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 2h12a2 2 0 0 1 2 2v25.75a.25.25 0 0 1-.25.25H3V4a2 2 0 0 1 2-2v0ZM20 12h7a2 2 0 0 1 2 2v16H19V13a1 1 0 0 1 1-1Z"
      stroke="#2D5BFF"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.13 26.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM6.13 21.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM6.13 16.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM6.13 11.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM6.13 6.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM11.13 21.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM11.13 16.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM11.13 11.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM11.13 6.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM16.13 26.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM16.13 21.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM16.13 16.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM16.708 11.708a1 1 0 0 0-.003-1.413 1 1 0 0 0-1.413-.004 1 1 0 0 0 .003 1.413 1 1 0 0 0 1.413.004ZM16.13 6.992a1 1 0 1 1-.26-1.983 1 1 0 0 1 .26 1.983ZM25 25a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM25 20a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM25 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM21 25a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM21 20a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM21 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      fill="#2D5BFF"
    />
  </svg>
);
